import bcrypt from "bcryptjs";
import {Company} from "./AuthContext.tsx"
import { ActivityInfo, ActivityListData, ListedSurveyData, CompanyInfo, DefaultReport, ReportInfo, DefaultActivity, ActivitySurveyStatusData } from "./pages/form/FormDataTypes.tsx";

const API_BASE = "http://localhost:5000";


async function FetchJson(url : string, options={})
{
    const result = await fetch(url, options);

    if (!result.ok) 
    {
        throw new Error(`API error: ${result.status}`);
    }
    return result.json();
} 

export function UseJsonApi()
{
/// LOGIN
    async function CheckLogin(companyName:string, password:string)
    {
        try 
        {
            const companies = await FetchJson(`${API_BASE}/login?companyName=${companyName}`);

            if (companies.length === 0) throw new Error("No company found");

            const company = companies[0];

            const isValid = await bcrypt.compare(password, company.password);

            if (!isValid)
            {
                throw new Error("Incorrect password.");
            }
            
            const returnCompany: Company = {
                "companyId":company.id,
                "companyName":company.companyName,
            };
            return returnCompany
        } 
        catch (error) 
        {
            console.log(`Could not fetch company. Msg: ${error}`);
            return false;
        }
    }

    // async function CheckIfUsernameExists(username:string)
    // {
    //     try 
    //     {
    //         const users = await FetchJson(`${API_BASE}/users?username=${username}`);
    //         if (users.length === 1) 
    //         {
    //             return true;    
    //         }
    //         else if (users.length === 0)
    //         {
    //             return false;
    //         }
    //         else
    //         {
    //             console.log(`Number of users: ${users.length}`)
    //             throw("Result from fetch resulted in undesired result.");
    //         }
    //     } 
    //     catch (error) 
    //     {
    //         console.log(`Could not fetch users. Msg: ${error}`);
    //     }
    // }
    async function CheckIfCompanyExists(companyName:string)
    {
        try 
        {
            const companies = await FetchJson(`${API_BASE}/companies?companyName=${companyName}`);
            if (companies.length === 1) 
            {
                return true;    
            }
            else if (companies.length === 0)
            {
                return false;
            }
            else
            {
                console.log(`Number of companies: ${companies.length}`)
                throw("Result from fetch resulted in undesired result.");
            }
        } 
        catch (error) 
        {
            console.log(`Could not fetch companies. Msg: ${error}`);
        }
    }

    async function AddNewCompany(companyName:string, password:string)
    {
        try 
        {
            const companies = await FetchJson(`${API_BASE}/companies`);
            const newId = Math.max(0, ...companies.map((u:any) => Number(u.id) || 0)) + 1;

            const saltRounds = 10;
            const hashPass = await bcrypt.hash(password, saltRounds);

            await FetchJson(`${API_BASE}/login`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    id:newId, 
                    companyName:companyName, 
                    password:hashPass
                })
            });

            return await FetchJson(`${API_BASE}/companies`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    id:newId, 
                    companyName:companyName, 
                    logo:"",
                    image:"",
                    doing:"",
                    solving:"",
                    target:"",
                    agendas:[]
                })
            });
        } 
        catch (error) 
        {
            console.log(`Could not add company. Msg: ${error}`);
        }
    }

/// COMPANIES
    async function GetCompanyIdFromName(companyName:string)
    {
        try 
        {
            const company = await FetchJson(`${API_BASE}/companies?companyName=${companyName}`);
            if (company.length === 1) 
            {
                return company[0].id;    
            }
            else
            {
                return null;
            }
        } 
        catch (error) 
        {
            console.log(`Could not fetch companies. Msg: ${error}`);
            return null;
        }
    }

    async function GetCompanyInfoFromId(companyId: number)
    {
        try 
        {
            const company = await FetchJson(`${API_BASE}/companies?id=${companyId}`);
            if (company.length === 1) 
            {
                return company[0];    
            }
            else
            {
                throw new Error("Could not get companies.");
            }
        } 
        catch (error) 
        {
            console.log(`Could not fetch companies. Msg: ${error}`);
            return null;
        }
    }

    async function GetEditableCompanyInfoFromId(companyId: number)
    {
        try 
        {
            const company = await FetchJson(`${API_BASE}/companies?id=${companyId}`);
            if (company.length === 1) 
            {
                return {
                    doing:company[0].doing || "",
                    solving:company[0].solving || "",
                    target:company[0].target || "",
                    agendas:company[0].agendas || []
                };    
            }
            else
            {
                throw new Error("Could not get companies.");
            }
        } 
        catch (error) 
        {
            console.log(`Could not fetch companies editable info. Msg: ${error}`);
            return null;
        }
    }

    async function UpdateCompanyInfo(id:number, data: CompanyInfo)
    {
        try 
        {
            return await FetchJson(`${API_BASE}/companies/${id}`, {
                    method: "PATCH",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify(data)
                });
        } 
        catch (error) 
        {
            console.log(`Could not update company info. Msg: ${error}`);
            return null;
        }
    }

/// REPORTS
    async function CreateNewReport(companyId: number)
    {
        try 
        {
            const reports = await FetchJson(`${API_BASE}/reports`);
            const newId = Math.max(0, ...reports.map((u:any) => Number(u.id) || 0)) + 1;

            const data :DefaultReport = {
                id:newId.toString(),
                companyId: companyId,
                title: "",
                startDate: "",
                endDate: "",
                description: "",
                surveys: [],
                activities: [],
                agendas: [],
                finished:false
            }; 

            const response:DefaultReport =  await FetchJson(`${API_BASE}/reports`, {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify(data)
                });
            
            return response
        } 
        catch (error) 
        {
            console.log(`Could not create a new report. Msg: ${error}`);
        }
        
    }

    async function UpdateReport(id:number, data: ReportInfo)
    {
        try 
        {
            return await FetchJson(`${API_BASE}/reports/${id}`, {
                    method: "PATCH",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify(data)
                });
        } 
        catch (error) 
        {
            console.log(`Could not update report. Msg: ${error}`);
            return null;
        }
    }

    async function GetReports(companyId: number)
    {
        try 
        {
            const reports = await FetchJson(`${API_BASE}/reports?companyId=${companyId}`);
            return reports;
        } 
        catch (error) 
        {
            console.log(`Could not fetch reports. Msg: ${error}`);
        }
    }

    async function GetReportFromId(reportId: number)
    {
        try 
        {
            const reports = await FetchJson(`${API_BASE}/reports?Id=${reportId}`);
            if (reports.length === 1) 
            {
                return reports[0];    
            }
            else
            {
                throw new Error("Either no report by that id, or multiple report with that id.");
            }
        } 
        catch (error) 
        {
            console.log(`Could not fetch report. Msg: ${error}`);
        }
    }

    async function GetEditableReportInfoFromId(reportId: number)
    {
        try 
        {
            const report = await FetchJson(`${API_BASE}/reports?id=${reportId}`);
            if (report.length === 1) 
            {
                return {
                    title:report[0].title || "", 
                    startDate:report[0].startDate || "", 
                    endDate:report[0].endDate || "", 
                    description:report[0].description || "", 
                    surveys:report[0].surveys || [], 
                    activities:report[0].activities || [], 
                    agendas:report[0].agendas || [],
                    finished:report[0].finished || false
                };    
            }
            else
            {
                throw new Error("Could not get companies.");
            }
        } 
        catch (error) 
        {
            console.log(`Could not fetch activity editable info. Msg: ${error}`);
            return null;
        }
    }



/// ACTIVITIES
    async function CreateNewActivity(companyId: number)
    {
        try 
        {
            const reports = await FetchJson(`${API_BASE}/activities`);
            const newId = Math.max(0, ...reports.map((u:any) => Number(u.id) || 0)) + 1;

            const data :DefaultActivity = {
                id:newId.toString(),
                companyId: companyId,
                title: "",
                type: "",
                startDate: "",
                endDate: "",
                description: "",
                agendas: [],
                surveys: [],
                attendees: 0,
                finished: false
            }; 

            const response:DefaultActivity =  await FetchJson(`${API_BASE}/activities`, {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify(data)
                });
            
            return response
        } 
        catch (error) 
        {
            console.log(`Could not create a new activity. Msg: ${error}`);
        }
        
    }

    async function GetActivities(companyId: number)
    {
        try 
        {
            const activities = await FetchJson(`${API_BASE}/activities?companyId=${companyId}`);
            return activities;
        } 
        catch (error) 
        {
            console.log(`Could not fetch activites. Msg: ${error}`);
        }
    }

    async function GetEditableActivityInfoFromId(activityId: number)
    {
        try 
        {
            const activity = await FetchJson(`${API_BASE}/activities?id=${activityId}`);
            if (activity.length === 1) 
            {
                return {
                    title: activity[0].title || "",
                    type: activity[0].type || "",
                    startDate: activity[0].startDate || "",
                    endDate: activity[0].endDate || "",
                    description: activity[0].description || "",
                    agendas: activity[0].agendas || [],
                    surveys: activity[0].surveys || [],
                    attendees: activity[0].attendees || 0,
                    finished: activity[0].finished || false
                };    
            }
            else
            {
                throw new Error("Could not get companies.");
            }
        } 
        catch (error) 
        {
            console.log(`Could not fetch activity editable info. Msg: ${error}`);
            return null;
        }
    }

    async function UpdateActivityInfo(id:number, data: ActivityInfo)
    {
        try 
        {
            return await FetchJson(`${API_BASE}/activities/${id}`, {
                    method: "PATCH",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify(data)
                });
        } 
        catch (error) 
        {
            console.log(`Could not update activity info. Msg: ${error}`);
            return null;
        }
    }

    async function GetActivitiesList(companyId: number)
    {
        try 
        {
            const surveys = await FetchJson(`${API_BASE}/activities?companyId=${companyId}`);

            let payload :ActivityListData[] = [];

            surveys.forEach(element => {
                payload.push({
                    id:element.id,
                    title:element.title,
                    surveys:element.surveys,
                    agendas:element.agendas
                } as ActivityListData);
            });

            return payload;
        } 
        catch (error) 
        {
            console.log(`Could not fetch activities. Msg: ${error}`);
        }
    }

/// SURVERYS
    async function GetSurveys(companyId: number)
    {
        try 
        {
            const surveys = await FetchJson(`${API_BASE}/surveys?companyId=${companyId}`);
            return surveys;
        } 
        catch (error) 
        {
            console.log(`Could not fetch surveys. Msg: ${error}`);
        }
    }

    async function GetSurveysList(companyId: number)
    {
        try 
        {
            const surveys = await FetchJson(`${API_BASE}/surveys?companyId=${companyId}`);

            let payload :ListedSurveyData[] = [];

            surveys.forEach(element => {
                payload.push({
                    id:element.id,
                    title:element.title
                } as ListedSurveyData);
            });

            return payload;
        } 
        catch (error) 
        {
            console.log(`Could not fetch surveys. Msg: ${error}`);
        }
    }

    async function GetSurvey(surveyId:string)
    {
        try 
        {
            const survey = await FetchJson(`${API_BASE}/surveys?id=${surveyId}`);
            if (survey.length === 1) 
            {
                return survey;    
            }
            else
            {
                throw new Error("Could not get Survey.");
            }
        } 
        catch (error) 
        {
            console.log(`Could not fetch survey. Msg: ${error}`);
            return null;
        }
    }

    async function CreateNewSurvey(title:string, companyId:number)
    {
      try 
        {
            const surveys = await FetchJson(`${API_BASE}/surveys`);
            const newId = Math.max(0, ...surveys.map((u:any) => Number(u.id) || 0)) + 1;
            const data = {
                id: newId.toString(),
                companyId: companyId,
                title: title,
                questions:[],
                active:false,
                published:false,
                link:""
            } 
            const response:FormData =  await FetchJson(`${API_BASE}/surveys`, {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify(data)
                });
            
            return response
        } 
        catch (error) 
        {
            console.log(`Could not create a new survey. Msg: ${error}`);
        }
    }

    async function GetEditableSurveyInfoFromID(surveyId:number)
    {
        try 
        {
            const survey = await FetchJson(`${API_BASE}/surveys?id=${surveyId}`);
            if (survey.length === 1) 
            {
                return {
                    title:survey[0].title || "",
                    questions:survey[0].questions || []
                };    
            }
            else
            {
                throw new Error("Could not get Survey.");
            }
        } 
        catch (error) 
        {
            console.log(`Could not fetch survey editable info. Msg: ${error}`);
            return null;
        }
    } 
    
    async function UpdateSurvey(id: number, data)
    {
        try 
        {
            return await FetchJson(`${API_BASE}/surveys/${id}`, {
                    method: "PATCH",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify(data)
                });
        } 
        catch (error) 
        {
            console.log(`Could not update surveys info. Msg: ${error}`);
            return null;
        }
    }

    async function GetSurveyViewInfo(surveyId:string)
    {
        try 
        {
            const reponses = await FetchJson(`${API_BASE}/responses?surveyId=${surveyId}`);
            let numberOfResponses = 0;
            if (reponses) 
            {
                 numberOfResponses = reponses.length;
            }
            else
            {
                throw new Error("Could not get responses.");
            }

            const survey = await FetchJson(`${API_BASE}/surveys?id=${surveyId}`);
            if (survey.length === 1) 
            {
                return {
                    title: survey[0].title || "",
                    link: survey[0].link || "",
                    active: survey[0].active || false,
                    numResponses: numberOfResponses || 0,
                }; 
            }
            else
            {
                throw new Error("Could not get Survey link.");
            }
        } 
        catch (error) 
        {
            console.log(`Could not fetch survey. Msg: ${error}`);
            return null;
        }
    }

    async function GetSurveyResult(surveyId:string)
    {
        try 
        {
            const responses = await FetchJson(`${API_BASE}/responses?surveyId=${surveyId}`);
            if (responses.length !== 0) 
            {
                const allAswers = responses.map(item => item.answers);
                return allAswers;    
            }
            else
            {
                throw new Error("Could not find any responses to that survey id.");
            }
        } 
        catch (error) 
        {
            console.log(`Could not fetch responses. Msg: ${error}`);
            return null;
        }
    }

    async function GetSurveyPublishedStatus(surveyId:string)
    {
        try 
        {
            const survey = await FetchJson(`${API_BASE}/surveys?id=${surveyId}`);
            if (survey.length === 1) 
            {
                return survey[0].published;   
            }
            else
            {
                throw new Error("Could not get Survey.");
            }
        } 
        catch (error) 
        {
            console.log(`Could not fetch survey active status. Msg: ${error}`);
            return null;
        }
    }
    async function PublishSurvey(surveyId:number)
    {
        try 
        {
            const link = `/survey/${surveyId}`;
            return await FetchJson(`${API_BASE}/surveys/${surveyId}`, {
                    method: "PATCH",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({active:true, published:true, link})
                });
        } 
        catch (error) 
        {
            console.log(`Could not activate survey. Msg: ${error}`);
            return null;
        }
    }
    async function DeactivateSurvey(surveyId:string)
    {
        try 
        {
            return await FetchJson(`${API_BASE}/surveys/${surveyId}`, {
                    method: "PATCH",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({active:false})
                });
        } 
        catch (error) 
        {
            console.log(`Could not deactivate survey. Msg: ${error}`);
            return null;
        }
    }

    async function StoreSurveyResponse(responseData)
    {
        try 
        {
            const responses = await FetchJson(`${API_BASE}/responses`);
            const newId = Math.max(0, ...responses.map((u:any) => Number(u.id) || 0)) + 1;

            const payload = {id:newId, ...responseData};

            return await FetchJson(`${API_BASE}/responses`, {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify(payload)
                });
        } 
        catch (error) 
        {
            console.log(`Could not activate survey. Msg: ${error}`);
            return null;
        }
    }


/// MISC
    async function DeleteResource(resource: string, id: string) {
        try 
        {
            const response = await fetch(`${API_BASE}/${resource}/${id}`, { 
                method: "DELETE",
                headers: { "Content-Type": "application/json" }
            });

            if (!response.ok) 
            {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            return true;
        } 
        catch (err) 
        {
            console.error(err);
            return false;
        }
    }

    async function FinishResource(resource: string, id: string)
    {
        try 
        {
            return await FetchJson(`${API_BASE}/${resource}/${id}`, {
                    method: "PATCH",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({finished:true})
                });
        } 
        catch (error) 
        {
            console.log(`Could not set finished variable of ${resource}. Msg: ${error}`);
            return null;
        }
    }

    async function GetReportActivityStatus(companyId:string)
    {
        try 
        {
            const reports = await FetchJson(`${API_BASE}/reports?companyId=${companyId}`);
            if (!reports) 
            {
                throw new Error("Could not get reoprts.");
            }

            const activities = await FetchJson(`${API_BASE}/activities?companyId=${companyId}`);
            if (!activities) 
            {
                throw new Error("Could not get activities.");
            }
            //reports.filter(item => item.finished ===  false).length
            let ar = reports.filter(item => item.finished ===  false).length;
            let fr = reports.length - ar;
            let aa = activities.filter(item => item.finished ===  false).length;
            let fa = activities.length - aa;

            // let payload:ActivitySurveyStatusData = {
            //     activeReports:ar,
            //     activeActivities:aa,
            //     finishedReports:fr,
            //     finishedActivities:fa
            // };

            // return payload;
        } 
        catch (error) 
        {
            console.log(`Could not fetch report/activity status. Msg: ${error}`);
            return null;
        }
    }

    async function GetSummaryData(companyId:number, activityIds:number[], surveyIds:number[])
    {
        try
        {
            const companyInfoRaw = await GetEditableCompanyInfoFromId(companyId);

            const companyInfo_DB = {
                questions: [
                        { question:"What is your company doing", answer:companyInfoRaw.doing},
                        { question:"What is your company solving", answer:companyInfoRaw.solving},
                        { question:"What is your companys target audience", answer:companyInfoRaw.target}
                    ],
                agendas:companyInfoRaw.agendas
            }

            const activities_db = await Promise.all(
                activityIds.map(async id => {
                    const activityRaw = await GetEditableActivityInfoFromId(id);
                    const {finished, ...activity} = activityRaw;
                    return activity;
                } 
            ));

            // console.log(activitiesRaw);
            
            const surveys_db = await Promise.all(
                surveyIds.map(async id => {
                    const survey = await GetSurveyViewInfo(id.toString());
                    return {surveyId:id, title:survey.title, numResponses:survey.numResponses};
                })
              );
            
            // console.log(surveysRaw);

            //FetchJson(`${API_BASE}/responses?surveyId=${id}`
            const responses_db = await Promise.all(
                surveyIds.map(async id => {
                    const response = await GetSurveyResult(id.toString());
                    return {surveyId:id, answers:response};
                } 
            ));
            // console.log(responsesRaw);

            return {companyInfo_DB, activities_db, surveys_db, responses_db}
        }
        catch (error) 
        {
            console.log(`Could not fetch the summary data. Msg: ${error}`);
            return null;
        }
    }

/// RETURN
    return {
        CheckLogin,
        CheckIfCompanyExists,
        AddNewCompany,
        GetCompanyIdFromName,
        GetCompanyInfoFromId,
        GetEditableCompanyInfoFromId,
        UpdateCompanyInfo,
        CreateNewReport,
        UpdateReport,
        GetReports,
        GetReportFromId,
        GetEditableReportInfoFromId,
        CreateNewActivity,
        GetActivities,
        GetEditableActivityInfoFromId,
        UpdateActivityInfo,
        GetActivitiesList,
        CreateNewSurvey,
        GetSurveys,
        GetSurveysList,
        GetSurvey,
        GetEditableSurveyInfoFromID,
        UpdateSurvey,
        GetSurveyViewInfo,
        GetSurveyResult,
        GetSurveyPublishedStatus,
        PublishSurvey,
        DeactivateSurvey,
        StoreSurveyResponse,
        DeleteResource,
        FinishResource,
        GetReportActivityStatus,
        GetSummaryData
    };
}